import React, { useContext } from "react";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { QtyOnHandValue } from "../../shared/QtyOnHandValue/QtyOnHandValue";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import IWarehouse from "../../../models/IWarehouse";
import UserService from "../../../services/UserService";
import CatalogItemService from "../../../services/CatalogItemService";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    row: IOrder_ItemUI;
    shippingWarehouse?: IWarehouse;
};

export const LineItemQtyInventoryDetail = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const showInventoryDetails = UserService.showInventoryDetails(supplierModel, userModel);

    // When warehouses are enabled, show the QoH for the order's shipping warehouse rather than the global total.
    // Only scope to the warehouse once the item's warehouse maps have loaded (same guard as RecentItemsRow):
    // QtyOnHandValue reads the warehouse figure from mapItem alone, so passing the warehouse without maps
    // would render 0 instead of falling back to the item's global qty_on_hand.
    const warehouseMapsLoaded = Array.isArray(props.row.Catalog_Item?.Warehouse_Catalog_Items_Maps);
    const shippingWarehouse = warehouseMapsLoaded ? props.shippingWarehouse : undefined;
    const qtyOnHandMapItem =
        shippingWarehouse && props.row.Catalog_Item
            ? CatalogItemService.getQtyOnHandWarehouseMapItem(props.row.Catalog_Item, shippingWarehouse)
            : undefined;

    const inventoryDetail =
        props.row.Catalog_Item?.has_inventory && showInventoryDetails ? (
            <div className="d-flex justify-content-end border-top border-bottom">
                <OwLabel title={"qoh"} postText={":"} className="me-2" />
                <QtyOnHandValue catalogItem={props.row.Catalog_Item} mapItem={qtyOnHandMapItem} shippingWarehouse={shippingWarehouse} />
            </div>
        ) : null;

    return inventoryDetail;
};
